// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1TqEx","topBottomGutter":"Layout_topBottomGutter__1U2ZY"};